<template>
  <div class="RealTimeView">
    <a-modal :visible="visible" width="414px" top="8vh" :footer="null" :maskClosable="true" @cancel="visible = false" wrapClassName="sixgod">
      <!-- 使用 ref 引用 iframe -->
      <iframe
        v-if="visible"
        ref="iframeRef"
        class="screen"
        :scrolling="false"
        :src="url"
        @load="onIframeLoad"
      ></iframe>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'RealTimeView',
  props: {
    val: Object
  },
  data() {
    return {
      visible: false,
      url: process.env.VUE_APP_TRACEH5TEMPLATE + '?type=iframe',
      loading: true
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    onIframeLoad() {
      this.loading = false;
      // 动态获取 targetOrigin
      const parser = document.createElement('a');
      parser.href = this.url;
      const targetOrigin = `${parser.protocol}//${parser.host}`;
      if (this.$refs.iframeRef) {
        try {
          // 检查数据是否可序列化
          JSON.stringify(this.val);
          this.$refs.iframeRef.contentWindow.postMessage(this.val, targetOrigin);
        } catch (error) {
          console.error('数据无法序列化:', error);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.RealTimeView {
  .screen {
    border: 10px solid red;
    width: 414px;
    height: 667px;
    border: 0;
    /* 隐藏滚动条，兼容多种浏览器 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */

    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
}
</style>

<style>
.sixgod .ant-modal-body {
  padding: 0px;
}
.sixgod iframe {
  width: 414px;
  height: 667px;
}
</style>
